import Param from './param';


export default class effectManager {
    constructor() {

        /* 共通パラメータ読み込み */
        this.param = new Param();

        this.w = window.innerWidth;

        // this.playerTrans = {
        //     speed : this.param.conf.pause/1000,
        //     ease : "SlowMo.ease.config(0.7, 0.7, false)",
        //     easeAlpha : "Expo.easeOut"
        // }

        this.playerTrans = {
            speed : this.param.conf.pause/1000,
            start : window.innerWidth * this.param.conf.offset.x,
            end   : 0,
        }

    }

    splitText($target){

        let text = new SplitText($target, {type:"words,chars"}),
            chars = text.chars;

        TweenMax.set(chars,{opacity:0});


    }

    setSvg($target){
        var g = $target.find("path,circle,line,rect,polyline,polygon");
        TweenLite.set(g, {drawSVG: "0%",visibility:"visible"});
    }

    copyIn($target,offsetX,speed){

        TweenMax.killChildTweensOf($target,{x:true,opacity:true})

        TweenMax.staggerFromTo($target,speed,
            {
                opacity:0,
                // scale:(1.1,1.1),
                x:offsetX,
            },
            {
                opacity:1,
                // scale:(1,1),
                x:0,
                ease:Power3.easeOut
            }
        ,0.1);

    }
    copyOut($target,offsetX,speed){



        TweenMax.staggerTo($target,speed,
            {
                opacity:0,
                // scale:(1.1,1.1),
                x:-offsetX,
                delay : 3.08,
                ease:Power3.easeIn
            }
            ,0.1);

    }
    copyOut2($target,offsetX,speed){

        TweenMax.staggerTo($target,speed,
            {
                opacity:0,
                // scale:(1.1,1.1),
                x:-offsetX,
                ease:Power3.easeIn
            }
            ,0.1);

    }
    playerTransX($target){
        let _this = this;
        let _w = window.innerWidth;
        if(_w < 1160){
            _w = 1160;
        }
        _this.playerTrans.end = (!_this.param.develop.loopOff)?-_w * this.param.conf.offset.x:0;

        TweenMax.fromTo($target,this.playerTrans.speed,
            {
                x : _this.playerTrans.start,
            },
            {
                x : _this.playerTrans.end,
                // delay:(type==="webgl")?0.2:0,
                // ease : SlowMo.ease.config(0.1, 0.7, false),
                ease : SlowMo.ease.config(0.1, 0.8, false),
                // ease : Expo.easeInOut,
                onStart:function () {
                },
                onComplete:function () {
                    $target.x = window.innerWidth*2;
                }
                // ease : Power0.easeNone
            }
        )


        /* [ 透明度が0になったくらいで画面外に移動 ] */
        // let _delay = (this.playerTrans.speed -1.1)*1000;
        // setTimeout(function () {
        //     TweenMax.set($target,{ x:window.innerWidth*2 });
        // },_delay);

    }
    /* 透過やコントラストなどの横移動以外を変化させるラッパー */
    playerProcessing($target,startVal,endVal,outVal){

        let _this = this;

        TweenMax.set($target,{ value:startVal });
        TweenMax.to($target,this.playerTrans.speed/8,
            {
                value : endVal,
                ease : Power2.easeIn,
                onComplete:function () {
                    if(!_this.param.develop.loopOff) TweenMax.to($target,_this.playerTrans.speed/10,
                        {
                            value : outVal,
                            delay : _this.playerTrans.speed/2,
                            // ease : SlowMo.ease.config(0.1, 0.7, false)
                            // ease : Power2.easeOut,
                            onComplete:function () {
                                TweenMax.set($target,{ value:0 });
                            }
                        }
                    )
                }
            }
        )
    }

    player($target,$rotTarget,$opTarget,$brightTarget,$contrastTarget){

        let _this = this;

        _this.playerTransX($target);

        setTimeout(function () {
            _this.playerProcessing($opTarget,0,1,0);
            _this.playerProcessing($brightTarget,0.1,0,1);
            _this.playerProcessing($contrastTarget,0.6,0,1);
        if(!_this.param.develop.loopOff){
            setTimeout(function () {
                // _this.copyOut($("#l-kv-copy .text >*"),301,0.88);
                _this.copyOut($("#l-kv-seek .sports li.is-current >* >*"),20,0.88);
            },9e2);
        }

        },5e2);


    }

    playerBody($target,$rotTarget,$opTarget){

        let _this = this;


        _this.playerTransX($target);



        TweenMax.set($opTarget,{ opacity:0 });
        TweenMax.to($opTarget,_this.playerTrans.speed/4,
            {
                opacity : 1,
                // ease : SlowMo.ease.config(0.1, 0.7, false)
                ease : Power2.easeIn,
                onComplate:function () {
                    if(!_this.param.develop.loopOff) TweenMax.to($opTarget,_this.playerTrans.speed/20,
                        {
                            opacity : 0,
                            delay : _this.playerTrans.speed/1.3,
                            // ease : SlowMo.ease.config(0.1, 0.7, false)
                            ease : Power2.easeOut
                        }
                    )

                }
            }
        )

        // setTimeout(function () {


        // },1e2);



    }

    seekbar(start,end,speed,type){


        let _ease,_delay;



        if(type=="show"){
            if($("#l-kv-seek-line-now").hasClass("is-show")) return;
            _ease = "Circ.easeOut";
            _delay = 0;
            $("#l-kv-seek-line-now").addClass("is-show");
        }else{
            _ease = "Power0.easeNone";
            _delay = 0.38;

        }


        TweenMax.fromTo($("#l-kv-seek-line-now").find(".left >*"),speed,
            {
                x: -start+"%",
            },
            {
                x: -end+"%",
                delay : _delay,
                ease: _ease,

            }
        );
        TweenMax.fromTo($("#l-kv-seek-line-now").find(".right >*"),speed,
            {
                x: start+"%",
            },
            {
                x: end+"%",
                delay : _delay,
                ease: _ease,
            }
        );

    }


}